const assetUrl = (path = '') => {
  if (!path) {
    return '';
  }

  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${process.env.PUBLIC_URL || ''}${encodeURI(normalized)}`;
};

export default assetUrl;
